import { Token, Keyword } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Result } from "@siteimprove/alfa-result";
import { Shorthand } from "../shorthand.js";
import LineHeight from "./line-height.js";
import Family from "./font-family.js";
import Size from "./font-size.js";
// Only keyword stretch are accepted in font, so we need to import the correct parser
import * as Stretch from "./font-stretch.js";
import Style from "./font-style.js";
import Weight from "./font-weight.js";
const { map, option, pair, right, delimited } = Parser;
// font may only set font-variant-caps to small-caps, but setting font
// does reset all font-variant-* longhand to initial value (this is good!)
const parsePrelude = (input) => {
    let style;
    let variant;
    let weight;
    let stretch;
    while (true) {
        for (const [remainder] of Token.parseWhitespace(input)) {
            input = remainder;
        }
        if (style === undefined) {
            const result = Style.parseBase(input);
            if (result.isOk()) {
                [input, style] = result.get();
                continue;
            }
        }
        if (variant === undefined) {
            const result = Keyword.parse("normal", "small-caps")(input);
            if (result.isOk()) {
                [input, variant] = result.get();
                continue;
            }
        }
        if (weight === undefined) {
            const result = Weight.parseBase(input);
            if (result.isOk()) {
                [input, weight] = result.get();
                continue;
            }
        }
        if (stretch === undefined) {
            const result = Stretch.parseAbsolute(input);
            if (result.isOk()) {
                [input, stretch] = result.get();
                continue;
            }
        }
        break;
    }
    return Result.of([
        input,
        [
            ["font-stretch", stretch ?? Keyword.of("initial")],
            ["font-style", style ?? Keyword.of("initial")],
            ["font-variant-caps", variant ?? Keyword.of("initial")],
            ["font-weight", weight ?? Keyword.of("initial")],
        ],
    ]);
};
const parse = pair(parsePrelude, pair(delimited(option(Token.parseWhitespace), Size.parseBase), pair(option(right(delimited(option(Token.parseWhitespace), Token.parseDelim("/")), LineHeight.parseBase)), delimited(option(Token.parseWhitespace), Family.parseBase))));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/font}
 * @internal
 */
export default Shorthand.of([
    "font-family",
    "font-size",
    "font-stretch",
    "font-style",
    "font-variant-caps",
    "font-variant-east-asian",
    "font-variant-ligatures",
    "font-variant-numeric",
    "font-variant-position",
    "font-weight",
    "line-height",
], map(parse, ([prelude, [size, [lineHeight, family]]]) => [
    ...prelude,
    ["font-size", size],
    ["line-height", lineHeight.getOr(Keyword.of("initial"))],
    ["font-family", family],
]));
//# sourceMappingURL=font.js.map